import { render, staticRenderFns } from "./shipout.vue?vue&type=template&id=a6934176&scoped=true"
import script from "./shipout.vue?vue&type=script&lang=js"
export * from "./shipout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6934176",
  null
  
)

export default component.exports